const FULL_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	timeZone: 'UTC',
});

const SHORT_FMT = new Intl.DateTimeFormat('en-GB', {
	day: 'numeric',
	month: 'short',
	timeZone: 'UTC',
});

export function formatDateFull(iso: string): string {
	return FULL_FMT.format(new Date(iso));
}

export function formatDateShort(iso: string): string {
	return SHORT_FMT.format(new Date(iso));
}
